import React, { useState, useEffect } from 'react';
import {
    Box,
    Button,
    Flex,
    Heading,
    Text,
    VStack,
    HStack,
    Image,
    IconButton,
    Modal,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalCloseButton,
    ModalBody,
    ModalFooter,
    FormControl,
    FormLabel,
    Input,
    Textarea,
    Accordion,
    AccordionItem,
    AccordionButton,
    AccordionPanel,
    AccordionIcon,
    useDisclosure,
    useColorModeValue,
    Spinner,
    useToast,
    Badge,
    Divider,
    Card,
    CardBody,
    CardHeader,
    Progress,
    Tooltip,
    Container,
    useBreakpointValue,
    Drawer,
    DrawerBody,
    DrawerFooter,
    DrawerHeader,
    DrawerOverlay,
    DrawerContent,
    DrawerCloseButton,
    Stack,
    Collapse,
    ScaleFade,
    SlideFade
} from '@chakra-ui/react';
import { FaTrash, FaVideo, FaPaperclip, FaArrowUp, FaArrowDown, FaPlay, FaClock, FaEye, FaBars, FaChevronDown, FaChevronRight, FaGraduationCap, FaBookOpen } from 'react-icons/fa';
import { FiLock, FiUnlock } from "react-icons/fi";
import { AddIcon, DeleteIcon, HamburgerIcon } from '@chakra-ui/icons';
import { CircularProgressbar } from 'react-circular-progressbar';
import 'react-circular-progressbar/dist/styles.css';
import axiosInstance from '../services/axiosInstance';
import { useParams } from 'react-router-dom';
import Sidebar2 from '../shared/Sidebar2';
import { deleteVideo, fetchCourseById, toggleChaptire } from '../services/courseService';
import VideoPlayer from '../shared/videoplayer';
import NewChapterToCourse from '../shared/newchapitreCreation';
import AddPartieForm from '../shared/AddPartieForm';
import { urlvideo } from '../services/urls';

const CourseDetailsContent = () => {
    const { id } = useParams();
    const [courseData, setCourseData] = useState(null);
    const [selectedVideo, setSelectedVideo] = useState(null);
    const [openChapterIndex, setOpenChapterIndex] = useState(0);
    const [openPartieIndex, setOpenPartieIndex] = useState(null);
    const [videoUploadModalOpen, setVideoUploadModalOpen] = useState(false);
    const [selectedChapterIndex, setSelectedChapterIndex] = useState(null);
    const [selectedPartieIndex, setSelectedPartieIndex] = useState(null);
    const [ChaterID, setChaterID] = useState(null);
    const [newVideo, setNewVideo] = useState({
        name: '',
        description: '',
        duree: '',
        file: null,
    });
    const [isCalculatingDuration, setIsCalculatingDuration] = useState(false);
    const [uploadAnimation, setUploadAnimation] = useState(false);
    const [uploadProgress, setUploadProgress] = useState(0);
    const [attachments, setAttachments] = useState([]);
    const [AttchmentName, setAttchmentName] = useState('');
    const [attachmentModalOpen, setAttachmentModalOpen] = useState(false);
    const { isOpen, onOpen, onClose } = useDisclosure();
    const [isAddNewPartieOpen, setisAddNewPartieOpen] = useState(false);
    const [isMobileSidebarOpen, setIsMobileSidebarOpen] = useState(false);
    const [expandedChapters, setExpandedChapters] = useState(new Set([0]));
    const [expandedParties, setExpandedParties] = useState(new Set());
    const toast = useToast();

    // Responsive breakpoints
    const isMobile = useBreakpointValue({ base: true, md: false });
    const isTablet = useBreakpointValue({ base: false, md: true, lg: false });
    const isDesktop = useBreakpointValue({ base: false, lg: true });
    
    // Responsive values
    const sidebarWidth = useBreakpointValue({ base: "0", md: "200px", lg: "250px" });
    const containerPadding = useBreakpointValue({ base: 4, md: 6, lg: 8 });
    const cardSpacing = useBreakpointValue({ base: 4, md: 6, lg: 8 });
    const headerSize = useBreakpointValue({ base: "lg", md: "xl", lg: "2xl" });
    const buttonSize = useBreakpointValue({ base: "sm", md: "md", lg: "lg" });
    const modalSize = useBreakpointValue({ base: "full", md: "xl", lg: "2xl" });

    // Enhanced color mode values
    const bgGradient = useColorModeValue(
        'linear(to-br, gray.50, blue.50)',
        'linear(to-br, gray.900, blue.900)'
    );
    const cardBg = useColorModeValue('white', 'gray.800');
    const chapterHeaderBg = useColorModeValue(
        'linear(to-r, blue.600, purple.600)',
        'linear(to-r, blue.700, purple.700)'
    );
    const chapterHoverBg = useColorModeValue(
        'linear(to-r, blue.700, purple.700)',
        'linear(to-r, blue.800, purple.800)'
    );
    const partieHeaderBg = useColorModeValue(
        'linear(to-r, teal.500, green.500)',
        'linear(to-r, teal.600, green.600)'
    );
    const partieHoverBg = useColorModeValue(
        'linear(to-r, teal.600, green.600)',
        'linear(to-r, teal.700, green.700)'
    );
    const accordionBodyBg = useColorModeValue('gray.50', 'gray.700');
    const borderColor = useColorModeValue('gray.200', 'gray.600');
    const textColor = useColorModeValue('gray.700', 'gray.200');
    const primaryColor = '#032D7F';
    const secondaryColor = '#4A90E2';

    const fetchCourseData = async () => {
        try {
            const response = await fetchCourseById(id);
            setCourseData(response.data);
            if (response.data.chapitres?.length > 0) {
                const firstChapter = response.data.chapitres[0];
                if (firstChapter.parties?.length > 0 && firstChapter.parties[0].videos?.length > 0) {
                    setSelectedVideo(firstChapter.parties[0].videos[0]);
                }
            }
        } catch (error) {
            console.error('Error fetching course data:', error);
            toast({
                title: "خطأ",
                description: "فشل تحميل بيانات الدورة",
                status: "error",
                duration: 3000,
                isClosable: true,
                position: "top-left"
            });
        }
    };

    // Function to calculate video duration
    const calculateVideoDuration = (file) => {
        return new Promise((resolve, reject) => {
            const video = document.createElement('video');
            video.preload = 'metadata';
            
            video.onloadedmetadata = () => {
                window.URL.revokeObjectURL(video.src);
                const duration = video.duration;
                const minutes = Math.floor(duration / 60);
                const seconds = Math.floor(duration % 60);
                const formattedDuration = `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
                resolve(formattedDuration);
            };
            
            video.onerror = () => {
                window.URL.revokeObjectURL(video.src);
                reject(new Error('Error loading video'));
            };
            
            video.src = URL.createObjectURL(file);
        });
    };

    // Enhanced video file handler with duration calculation
    const handleVideoFileChange = async (file) => {
        if (file) {
            setIsCalculatingDuration(true);
            try {
                const duration = await calculateVideoDuration(file);
                setNewVideo(prev => ({
                    ...prev,
                    file: file,
                    duree: duration,
                    name: prev.name || file.name.replace(/\.[^/.]+$/, "") // Auto-fill name if empty
                }));
                
                toast({
                    title: "تم حساب المدة",
                    description: `مدة الفيديو: ${duration}`,
                    status: "success",
                    duration: 2000,
                    isClosable: true,
                    position: "top-left"
                });
            } catch (error) {
                console.error('Error calculating duration:', error);
                setNewVideo(prev => ({
                    ...prev,
                    file: file,
                    name: prev.name || file.name.replace(/\.[^/.]+$/, "")
                }));
                
                toast({
                    title: "تحذير",
                    description: "لم يتم حساب مدة الفيديو تلقائياً، يرجى إدخالها يدوياً",
                    status: "warning",
                    duration: 3000,
                    isClosable: true,
                    position: "top-left"
                });
            } finally {
                setIsCalculatingDuration(false);
            }
        }
    };

    useEffect(() => {
        fetchCourseData();
    }, [id]);

    const handleVideoSelect = (video) => setSelectedVideo(video);

    const toggleChapter = (index) => {
        const newExpanded = new Set(expandedChapters);
        if (newExpanded.has(index)) {
            newExpanded.delete(index);
        } else {
            newExpanded.add(index);
        }
        setExpandedChapters(newExpanded);
    };

    const togglePartie = (chapterIndex, partieIndex) => {
        const key = `${chapterIndex}-${partieIndex}`;
        const newExpanded = new Set(expandedParties);
        if (newExpanded.has(key)) {
            newExpanded.delete(key);
        } else {
            newExpanded.add(key);
        }
        setExpandedParties(newExpanded);
    };

    const handleDeleteVideo = async (chapterIndex, partieIndex, videoId) => {
        try {
            await deleteVideo(id, chapterIndex, partieIndex, videoId);
            fetchCourseData();
            setSelectedVideo(null);
            toast({
                title: "تم الحذف",
                description: "تم حذف الفيديو بنجاح",
                status: "success",
                duration: 3000,
                isClosable: true,
                position: "top-left"
            });
        } catch (error) {
            console.error('Error deleting video:', error);
            toast({
                title: "خطأ",
                description: "فشل حذف الفيديو",
                status: "error",
                duration: 3000,
                isClosable: true,
                position: "top-left"
            });
        }
    };

    const openVideoUploadModal = (chapterIndex, partieIndex) => {
        setSelectedChapterIndex(chapterIndex);
        setSelectedPartieIndex(partieIndex);
        setVideoUploadModalOpen(true);
    };

    const handleCloseVideoUploadModal = () => {
        setVideoUploadModalOpen(false);
        setNewVideo({
            name: '',
            description: '',
            duree: '',
            file: null,
        });
        setUploadProgress(0);
        setIsCalculatingDuration(false);
        setUploadAnimation(false);
    };

    const handleAddVideo = async () => {
        if (selectedChapterIndex !== null && selectedPartieIndex !== null && courseData && newVideo.file) {
            try {
                setUploadAnimation(true);
                const formData = new FormData();
                formData.append('video', newVideo.file);
                formData.append('nomvideo', newVideo.name);
                formData.append('description', newVideo.description);
                formData.append('duree', newVideo.duree);
                formData.append('chapitreIndex', selectedChapterIndex);
                formData.append('partieIndex', selectedPartieIndex);

                await axiosInstance.post(`/courses/course/${id}/videos`, formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                    },
                    onUploadProgress: (progressEvent) => {
                        const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
                        setUploadProgress(percentCompleted);
                    },
                });

                // Success animation delay
                setTimeout(() => {
                    fetchCourseData();
                    toast({
                        title: "تم الرفع بنجاح! 🎉",
                        description: `تم رفع الفيديو "${newVideo.name}" بنجاح`,
                        status: "success",
                        duration: 4000,
                        isClosable: true,
                        position: "top-left"
                    });
                    handleCloseVideoUploadModal();
                }, 500);
            } catch (error) {
                console.error('Error uploading video:', error);
                setUploadAnimation(false);
                toast({
                    title: "خطأ في الرفع ❌",
                    description: "فشل رفع الفيديو، يرجى المحاولة مرة أخرى",
                    status: "error",
                    duration: 4000,
                    isClosable: true,
                    position: "top-left"
                });
            }
        }
    };

    const handleDeletePartie = async (chapterIndex, partieIndex) => {
        try {
            const courseId = courseData._id;
            const chapitreId = courseData.chapitres[chapterIndex]._id;
            const partieId = courseData.chapitres[chapterIndex].parties[partieIndex]._id;

            await axiosInstance.delete(`courses/courses/${courseId}/chapters/${chapitreId}/parties/${partieId}`);

            const updatedCourseData = { ...courseData };
            updatedCourseData.chapitres[chapterIndex].parties.splice(partieIndex, 1);
            setCourseData(updatedCourseData);

            toast({
                title: "تم الحذف",
                description: "تم حذف الجزء بنجاح",
                status: "success",
                duration: 3000,
                isClosable: true,
                position: "top-left"
            });
        } catch (error) {
            console.error('Error deleting part:', error);
            toast({
                title: "خطأ",
                description: "فشل حذف الجزء",
                status: "error",
                duration: 3000,
                isClosable: true,
                position: "top-left"
            });
        }
    };

    const saveAttachmentsToPartie = async (chapterIndex, partieIndex, attachment) => {
        try {
            if (!attachment) {
                toast({
                    title: "خطأ",
                    description: "لم يتم توفير مرفق",
                    status: "error",
                    duration: 3000,
                    isClosable: true,
                    position: "top-left"
                });
                return;
            }

            const formData = new FormData();
            formData.append('file', attachment);
            formData.append('nom', AttchmentName);

            const course = courseData;
            if (!course) {
                toast({
                    title: "خطأ",
                    description: "لم يتم العثور على الدورة",
                    status: "error",
                    duration: 3000,
                    isClosable: true,
                    position: "top-left"
                });
                return;
            }

            const chapitreId = course.chapitres[chapterIndex]?._id;
            const partieId = course.chapitres[chapterIndex]?.parties[partieIndex]?._id;

            if (!chapitreId || !partieId) {
                toast({
                    title: "خطأ",
                    description: "لم يتم العثور على معرف ال محور أو الجزء",
                    status: "error",
                    duration: 3000,
                    isClosable: true,
                    position: "top-left"
                });
                return;
            }

            await axiosInstance.post(
                `/courses/attachment/${id}/chapters/${chapitreId}/parties/${partieId}/add`,
                formData,
                {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                    },
                }
            );

            setAttachmentModalOpen(false);
            fetchCourseData();

            toast({
                title: "تم الرفع",
                description: "تم رفع المرفق بنجاح",
                status: "success",
                duration: 3000,
                isClosable: true,
                position: "top-left"
            });
        } catch (error) {
            console.error('Error saving attachments:', error);
            toast({
                title: "خطأ",
                description: "فشل رفع المرفق",
                status: "error",
                duration: 3000,
                isClosable: true,
                position: "top-left"
            });
        }
    };

    const toggleChapterState = async (chapterId) => {
        try {
            await toggleChaptire(id, chapterId);
            fetchCourseData();
        } catch (error) {
            console.error('Error toggling chapter state:', error);
            toast({
                title: "خطأ",
                description: "فشل تغيير حالة ال محور",
                status: "error",
                duration: 3000,
                isClosable: true,
                position: "top-left"
            });
        }
    };

    const handleDeleteAttachment = async (partieIndex, attIndex, chapIndex) => {
        try {
            const chapitreId = courseData.chapitres[chapIndex]._id;
            const partieId = courseData.chapitres[chapIndex].parties[partieIndex]._id;
            const attachmentId = courseData.chapitres[chapIndex].parties[partieIndex].attachments[attIndex]._id;

            await axiosInstance.delete(
                `/courses/attachment/${id}/chapters/${chapitreId}/parties/${partieId}/attachments/${attachmentId}`
            );

            const updatedParties = [...courseData.chapitres[chapIndex].parties];
            updatedParties[partieIndex].attachments.splice(attIndex, 1);

            setCourseData(prevData => {
                const updatedChapters = [...prevData.chapitres];
                updatedChapters[chapIndex].parties = updatedParties;
                return { ...prevData, chapitres: updatedChapters };
            });

            toast({
                title: "تم الحذف",
                description: "تم حذف المرفق بنجاح",
                status: "success",
                duration: 3000,
                isClosable: true,
                position: "top-left"
            });
        } catch (error) {
            console.error("Error deleting attachment:", error);
            toast({
                title: "خطأ",
                description: "فشل حذف المرفق",
                status: "error",
                duration: 3000,
                isClosable: true,
                position: "top-left"
            });
        }
    };

    const openNewPartieModal = (chapterId) => {
        setChaterID(chapterId);
        setisAddNewPartieOpen(true);
    };

    const handleReorderVideos = async (chapterIndex, partieIndex, videoIndex, direction) => {
        try {
            const updatedVideos = [...courseData.chapitres[chapterIndex].parties[partieIndex].videos];
            const temp = updatedVideos[videoIndex];

            if (direction === 'up' && videoIndex > 0) {
                updatedVideos[videoIndex] = updatedVideos[videoIndex - 1];
                updatedVideos[videoIndex - 1] = temp;
            } else if (direction === 'down' && videoIndex < updatedVideos.length - 1) {
                updatedVideos[videoIndex] = updatedVideos[videoIndex + 1];
                updatedVideos[videoIndex + 1] = temp;
            }

            await axiosInstance.put(
                `courses/updatedVideos/${id}/chapters/${chapterIndex}/parties/${partieIndex}/reorder-videos`,
                { videos: updatedVideos }
            );

            fetchCourseData();
        } catch (error) {
            console.error('Error reordering videos:', error);
            toast({
                title: "خطأ",
                description: "فشل إعادة ترتيب الفيديوهات",
                status: "error",
                duration: 3000,
                isClosable: true,
                position: "top-left"
            });
        }
    };

    if (!courseData) {
        return (
            <Flex
                justify="center"
                align="center"
                h="100vh"
                bgGradient={bgGradient}
            >
                <VStack spacing={4}>
                    <Spinner
                        size="xl"
                        color={primaryColor}
                        thickness="4px"
                    />
                    <Text color={textColor} fontSize="lg">جاري تحميل بيانات الدورة...</Text>
                </VStack>
            </Flex>
        );
    }

    return (
        <>
            <Flex h="100vh" overflowY="scroll" dir="rtl" bgGradient={bgGradient}>
                {/* Desktop Sidebar */}
                <Sidebar2 />
                <Container 
                    maxW="full" 
                    p={0}
                    mr={isMobile ? 0 : sidebarWidth}
                    transition="margin 0.3s ease"
                >
                    <Flex flex="1" direction="column" overflowY="auto">
                        {/* Mobile Header with Menu Button */}
                        {isMobile && (
                            <Box p={4} bg={cardBg} shadow="sm">
                                <HStack justify="space-between">
                                    <IconButton
                                        icon={<HamburgerIcon />}
                                        variant="ghost"
                                        onClick={() => setIsMobileSidebarOpen(true)}
                                        aria-label="Open menu"
                                    />
                                    <Text fontSize="lg" fontWeight="bold" color={primaryColor}>
                                        تحرير الدورة
                                    </Text>
                                </HStack>
                            </Box>
                        )}

                        <Box p={containerPadding}>
                            {/* Enhanced Header */}
                            <Card mb={cardSpacing} bg={cardBg} shadow="2xl" borderRadius="3xl" overflow="hidden">
                                <CardHeader bgGradient="linear(to-r, blue.600, purple.600)" color="white" py={8}>
                                    <VStack align="start" spacing={6}>
                                        <HStack spacing={4}>
                                            <Box
                                                p={3}
                                                bg="whiteAlpha.200"
                                                borderRadius="xl"
                                                backdropFilter="blur(10px)"
                                            >
                                                <FaGraduationCap size={32} />
                                            </Box>
                                            <VStack align="start" spacing={2}>
                                                <Heading
                                                    size={headerSize}
                                                    textAlign="right"
                                                    fontWeight="bold"
                                                    textShadow="0 2px 4px rgba(0,0,0,0.3)"
                                                >
                                                    الدورة: {courseData.name}
                                                </Heading>
                                                <Badge
                                                    bg="whiteAlpha.200"
                                                    color="white"
                                                    fontSize={isMobile ? "sm" : "md"}
                                                    px={4}
                                                    py={2}
                                                    borderRadius="full"
                                                    backdropFilter="blur(10px)"
                                                >
                                                    {courseData.chapitres?.length || 0}  محور
                                                </Badge>
                                            </VStack>
                                        </HStack>
                                    </VStack>
                                </CardHeader>
                            </Card>

                            <Stack 
                                direction={{ base: "column", lg: "row" }} 
                                spacing={cardSpacing}
                                align="stretch"
                            >
                                {/* Enhanced Chapters List */}
                                <Box 
                                    flex="1" 
                                    maxW={{ base: "100%", lg: "45%" }}
                                    order={{ base: 2, lg: 1 }}
                                >
                                    <Card bg={cardBg} shadow="2xl" borderRadius="3xl" overflow="hidden">
                                        <CardHeader bgGradient="linear(to-r, indigo.600, purple.600)" color="white" py={8}>
                                            <Stack 
                                                direction={{ base: "column", md: "row" }}
                                                justify="space-between" 
                                                align={{ base: "stretch", md: "center" }}
                                                spacing={4}
                                            >
                                                <HStack spacing={3}>
                                                    <Box
                                                        p={2}
                                                        bg="whiteAlpha.200"
                                                        borderRadius="lg"
                                                        backdropFilter="blur(10px)"
                                                    >
                                                        <FaBookOpen size={24} />
                                                    </Box>
                                                    <Text
                                                        fontSize={{ base: "lg", md: "xl", lg: "2xl" }}
                                                        fontWeight="bold"
                                                        textShadow="0 2px 4px rgba(0,0,0,0.3)"
                                                        color="black"
                                                    >
                                                        قائمة المحاور
                                                    </Text>
                                                </HStack>
                                                <Button
                                                    rightIcon={<AddIcon />}
                                                    size={buttonSize}
                                                    bg="blue.500"
                                                    color="white"
                                                    onClick={onOpen}
                                                    borderRadius="xl"
                                                    px={6}
                                                    w={{ base: "full", md: "auto" }}
                                                    backdropFilter="blur(10px)"
                                                    border="1px solid"
                                                    borderColor="blue.300"
                                                    _hover={{
                                                        bg: "blue.300",
                                                        transform: "translateY(-2px)",
                                                        shadow: "xl"
                                                    }}
                                                    transition="all 0.3s ease"
                                                >
                                                    إضافة  محور جديد
                                                </Button>
                                            </Stack>
                                        </CardHeader>

                                        <CardBody p={0}>
                                            <VStack spacing={0} align="stretch">
                                                {courseData.chapitres.map((chapter, chapterIndex) => (
                                                    <Box key={chapter._id}>
                                                        {/* Enhanced Chapter Header */}
                                                        <Box
                                                            bgGradient={chapterHeaderBg}
                                                            color="white"
                                                            p={{ base: 6, md: 8 }}
                                                            cursor="pointer"
                                                            onClick={() => toggleChapter(chapterIndex)}
                                                            _hover={{
                                                                bgGradient: chapterHoverBg,
                                                                transform: "scale(1.01)"
                                                            }}
                                                            transition="all 0.4s cubic-bezier(0.4, 0, 0.2, 1)"
                                                            position="relative"
                                                            overflow="hidden"
                                                            borderBottom="1px solid"
                                                            borderColor="whiteAlpha.200"
                                                            _before={{
                                                                content: '""',
                                                                position: "absolute",
                                                                top: 0,
                                                                left: 0,
                                                                right: 0,
                                                                bottom: 0,
                                                                bgGradient: "linear(45deg, transparent 30%, whiteAlpha.100 50%, transparent 70%)",
                                                                transform: "translateX(-100%)",
                                                                transition: "transform 0.6s ease",
                                                            }}
                                                            _hover={{
                                                                _before: {
                                                                    transform: "translateX(100%)"
                                                                }
                                                            }}
                                                        >
                                                            <Stack 
                                                                direction={{ base: "column", md: "row" }}
                                                                justify="space-between" 
                                                                w="full"
                                                                spacing={4}
                                                                position="relative"
                                                                zIndex={1}
                                                            >
                                                                <HStack 
                                                                    spacing={4}
                                                                    justify={{ base: "center", md: "flex-start" }}
                                                                    flexWrap="wrap"
                                                                >
                                                                    <Box
                                                                        transform={expandedChapters.has(chapterIndex) ? "rotate(90deg)" : "rotate(0deg)"}
                                                                        transition="transform 0.3s ease"
                                                                    >
                                                                        <FaChevronRight size={20} />
                                                                    </Box>
                                                                    <Tooltip
                                                                        label={chapter.isLocked ? " محور مقفل" : " محور مفتوح"}
                                                                        placement="top"
                                                                    >
                                                                        <IconButton
                                                                            icon={chapter.isLocked ? <FiLock /> : <FiUnlock />}
                                                                            size="sm"
                                                                            bg={chapter.isLocked ? "red.500" : "green.500"}
                                                                            color="white"
                                                                            onClick={(e) => {
                                                                                e.stopPropagation();
                                                                                toggleChapterState(chapter._id);
                                                                            }}
                                                                            borderRadius="full"
                                                                            _hover={{
                                                                                bg: chapter.isLocked ? "red.600" : "green.600",
                                                                                transform: "scale(1.1)"
                                                                            }}
                                                                            transition="all 0.3s ease"
                                                                        />
                                                                    </Tooltip>
                                                                    <Badge
                                                                        bg="whiteAlpha.200"
                                                                        color="white"
                                                                        borderRadius="full"
                                                                        px={4}
                                                                        py={2}
                                                                        backdropFilter="blur(10px)"
                                                                        border="1px solid"
                                                                        borderColor="whiteAlpha.300"
                                                                    >
                                                                        {chapter.parties?.length || 0} جزء
                                                                    </Badge>
                                                                </HStack>
                                                                <VStack 
                                                                    align={{ base: "center", md: "end" }} 
                                                                    spacing={2}
                                                                >
                                                                    <Text
                                                                        fontWeight="bold"
                                                                        fontSize={{ base: "lg", md: "xl" }}
                                                                        textAlign={{ base: "center", md: "right" }}
                                                                        textShadow="0 2px 4px rgba(0,0,0,0.3)"
                                                                    >
                                                                        {chapter.nom}
                                                                    </Text>
                                                                    <Text
                                                                        fontSize="sm"
                                                                        opacity={0.9}
                                                                        textAlign={{ base: "center", md: "right" }}
                                                                        noOfLines={2}
                                                                    >
                                                                        {chapter.description}
                                                                    </Text>
                                                                </VStack>
                                                            </Stack>
                                                        </Box>

                                                        {/* Enhanced Chapter Content */}
                                                        <Collapse in={expandedChapters.has(chapterIndex)} animateOpacity>
                                                            <Box bg={accordionBodyBg} p={0}>
                                                                <VStack spacing={0} align="stretch">
                                                                    {chapter.parties?.map((partie, partieIndex) => (
                                                                        <SlideFade 
                                                                            key={partie._id} 
                                                                            in={expandedChapters.has(chapterIndex)}
                                                                            offsetY="20px"
                                                                            delay={partieIndex * 0.1}
                                                                        >
                                                                            <Box m={4}>
                                                                                {/* Enhanced Partie Header */}
                                                                                <Box
                                                                                    bgGradient={partieHeaderBg}
                                                                                    color="white"
                                                                                    p={{ base: 4, md: 6 }}
                                                                                    borderRadius="xl"
                                                                                    cursor="pointer"
                                                                                    onClick={() => togglePartie(chapterIndex, partieIndex)}
                                                                                    _hover={{
                                                                                        bgGradient: partieHoverBg,
                                                                                        transform: "translateY(-2px)",
                                                                                        shadow: "xl"
                                                                                    }}
                                                                                    transition="all 0.4s cubic-bezier(0.4, 0, 0.2, 1)"
                                                                                    position="relative"
                                                                                    overflow="hidden"
                                                                                    _before={{
                                                                                        content: '""',
                                                                                        position: "absolute",
                                                                                        top: 0,
                                                                                        left: 0,
                                                                                        right: 0,
                                                                                        bottom: 0,
                                                                                        bgGradient: "linear(45deg, transparent 30%, whiteAlpha.100 50%, transparent 70%)",
                                                                                        transform: "translateX(-100%)",
                                                                                        transition: "transform 0.6s ease",
                                                                                    }}
                                                                                    _hover={{
                                                                                        _before: {
                                                                                            transform: "translateX(100%)"
                                                                                        }
                                                                                    }}
                                                                                >
                                                                                    <Stack 
                                                                                        direction={{ base: "column", md: "row" }}
                                                                                        justify="space-between"
                                                                                        spacing={4}
                                                                                        position="relative"
                                                                                        zIndex={1}
                                                                                    >
                                                                                        <HStack 
                                                                                            spacing={3}
                                                                                            justify={{ base: "center", md: "flex-start" }}
                                                                                            flexWrap="wrap"
                                                                                        >
                                                                                            <Box
                                                                                                transform={expandedParties.has(`${chapterIndex}-${partieIndex}`) ? "rotate(90deg)" : "rotate(0deg)"}
                                                                                                transition="transform 0.3s ease"
                                                                                            >
                                                                                                <FaChevronRight size={16} />
                                                                                            </Box>
                                                                                            <Tooltip label="حذف الجزء">
                                                                                                <IconButton
                                                                                                    icon={<DeleteIcon />}
                                                                                                    size="sm"
                                                                                                    bg="red.500"
                                                                                                    color="white"
                                                                                                    onClick={(e) => {
                                                                                                        e.stopPropagation();
                                                                                                        handleDeletePartie(chapterIndex, partieIndex);
                                                                                                    }}
                                                                                                    borderRadius="full"
                                                                                                    _hover={{
                                                                                                        bg: "red.600",
                                                                                                        transform: "scale(1.1)"
                                                                                                    }}
                                                                                                    transition="all 0.3s ease"
                                                                                                />
                                                                                            </Tooltip>
                                                                                            <Tooltip label="إضافة مرفق">
                                                                                                <IconButton
                                                                                                    icon={<FaPaperclip />}
                                                                                                    size="sm"
                                                                                                    bg="blue.500"
                                                                                                    color="white"
                                                                                                    onClick={(e) => {
                                                                                                        e.stopPropagation();
                                                                                                        setSelectedChapterIndex(chapterIndex);
                                                                                                        setSelectedPartieIndex(partieIndex);
                                                                                                        setAttachmentModalOpen(true);
                                                                                                    }}
                                                                                                    borderRadius="full"
                                                                                                    _hover={{
                                                                                                        bg: "blue.600",
                                                                                                        transform: "scale(1.1)"
                                                                                                    }}
                                                                                                    transition="all 0.3s ease"
                                                                                                />
                                                                                            </Tooltip>
                                                                                            <Tooltip label="إضافة فيديو">
                                                                                                <IconButton
                                                                                                    icon={<FaVideo />}
                                                                                                    size="sm"
                                                                                                    bg="green.500"
                                                                                                    color="white"
                                                                                                    onClick={(e) => {
                                                                                                        e.stopPropagation();
                                                                                                        openVideoUploadModal(chapterIndex, partieIndex);
                                                                                                    }}
                                                                                                    borderRadius="full"
                                                                                                    _hover={{
                                                                                                        bg: "green.600",
                                                                                                        transform: "scale(1.1)"
                                                                                                    }}
                                                                                                    transition="all 0.3s ease"
                                                                                                />
                                                                                            </Tooltip>
                                                                                            <Badge
                                                                                                bg="whiteAlpha.200"
                                                                                                color="white"
                                                                                                borderRadius="full"
                                                                                                px={3}
                                                                                                py={1}
                                                                                                backdropFilter="blur(10px)"
                                                                                                border="1px solid"
                                                                                                borderColor="whiteAlpha.300"
                                                                                            >
                                                                                                {partie.videos?.length || 0} فيديو
                                                                                            </Badge>
                                                                                        </HStack>
                                                                                        <VStack 
                                                                                            align={{ base: "center", md: "end" }} 
                                                                                            spacing={1}
                                                                                        >
                                                                                            <Text
                                                                                                fontWeight="semibold"
                                                                                                fontSize={{ base: "md", md: "lg" }}
                                                                                                textAlign={{ base: "center", md: "right" }}
                                                                                                textShadow="0 2px 4px rgba(0,0,0,0.3)"
                                                                                            >
                                                                                                {partie.name}
                                                                                            </Text>
                                                                                            <Text
                                                                                                fontSize="sm"
                                                                                                opacity={0.9}
                                                                                                textAlign={{ base: "center", md: "right" }}
                                                                                                noOfLines={2}
                                                                                            >
                                                                                                {partie.description}
                                                                                            </Text>
                                                                                        </VStack>
                                                                                    </Stack>
                                                                                </Box>

                                                                                {/* Enhanced Partie Content */}
                                                                                <Collapse in={expandedParties.has(`${chapterIndex}-${partieIndex}`)} animateOpacity>
                                                                                    <Box 
                                                                                        bg="white" 
                                                                                        borderRadius="xl" 
                                                                                        mt={2} 
                                                                                        p={6}
                                                                                        shadow="lg"
                                                                                        border="1px solid"
                                                                                        borderColor="gray.200"
                                                                                    >
                                                                                        {/* Videos List */}
                                                                                        <VStack spacing={4} align="stretch">
                                                                                            {partie.videos?.map((video, videoIndex) => (
                                                                                                <ScaleFade 
                                                                                                    key={video._id} 
                                                                                                    in={expandedParties.has(`${chapterIndex}-${partieIndex}`)}
                                                                                                    delay={videoIndex * 0.1}
                                                                                                >
                                                                                                    <Card
                                                                                                        variant="outline"
                                                                                                        size="sm"
                                                                                                        cursor="pointer"
                                                                                                        onClick={() => handleVideoSelect(video)}
                                                                                                        bg={selectedVideo?._id === video._id ? "blue.50" : "white"}
                                                                                                        borderColor={selectedVideo?._id === video._id ? "blue.400" : "gray.200"}
                                                                                                        borderWidth="2px"
                                                                                                        borderRadius="xl"
                                                                                                        _hover={{
                                                                                                            bg: "blue.50",
                                                                                                            borderColor: "blue.400",
                                                                                                            transform: "translateY(-2px)",
                                                                                                            shadow: "lg"
                                                                                                        }}
                                                                                                        transition="all 0.3s cubic-bezier(0.4, 0, 0.2, 1)"
                                                                                                        position="relative"
                                                                                                        overflow="hidden"
                                                                                                    >
                                                                                                        <CardBody p={4}>
                                                                                                            <Stack 
                                                                                                                direction={{ base: "column", sm: "row" }}
                                                                                                                justify="space-between"
                                                                                                                align={{ base: "stretch", sm: "center" }}
                                                                                                                spacing={3}
                                                                                                            >
                                                                                                                <HStack 
                                                                                                                    spacing={2}
                                                                                                                    justify={{ base: "center", sm: "flex-start" }}
                                                                                                                    flexWrap="wrap"
                                                                                                                >
                                                                                                                    <Tooltip label="حذف الفيديو">
                                                                                                                        <IconButton
                                                                                                                            icon={<FaTrash />}
                                                                                                                            size="xs"
                                                                                                                            colorScheme="red"
                                                                                                                            variant="ghost"
                                                                                                                            onClick={(e) => {
                                                                                                                                e.stopPropagation();
                                                                                                                                handleDeleteVideo(chapterIndex, partieIndex, video._id);
                                                                                                                            }}
                                                                                                                            borderRadius="full"
                                                                                                                            _hover={{
                                                                                                                                bg: "red.100",
                                                                                                                                transform: "scale(1.1)"
                                                                                                                            }}
                                                                                                                        />
                                                                                                                    </Tooltip>
                                                                                                                    <Tooltip label="تحريك لأعلى">
                                                                                                                        <IconButton
                                                                                                                            icon={<FaArrowUp />}
                                                                                                                            size="xs"
                                                                                                                            variant="ghost"
                                                                                                                            onClick={(e) => {
                                                                                                                                e.stopPropagation();
                                                                                                                                handleReorderVideos(chapterIndex, partieIndex, videoIndex, 'up');
                                                                                                                            }}
                                                                                                                            isDisabled={videoIndex === 0}
                                                                                                                            borderRadius="full"
                                                                                                                            _hover={{
                                                                                                                                bg: "gray.100",
                                                                                                                                transform: "scale(1.1)"
                                                                                                                            }}
                                                                                                                        />
                                                                                                                    </Tooltip>
                                                                                                                    <Tooltip label="تحريك لأسفل">
                                                                                                                        <IconButton
                                                                                                                            icon={<FaArrowDown />}
                                                                                                                            size="xs"
                                                                                                                            variant="ghost"
                                                                                                                            onClick={(e) => {
                                                                                                                                e.stopPropagation();
                                                                                                                                handleReorderVideos(chapterIndex, partieIndex, videoIndex, 'down');
                                                                                                                            }}
                                                                                                                            isDisabled={videoIndex === partie.videos.length - 1}
                                                                                                                            borderRadius="full"
                                                                                                                            _hover={{
                                                                                                                                bg: "gray.100",
                                                                                                                                transform: "scale(1.1)"
                                                                                                                            }}
                                                                                                                        />
                                                                                                                    </Tooltip>
                                                                                                                    <Badge
                                                                                                                        colorScheme="green"
                                                                                                                        size="sm"
                                                                                                                        borderRadius="full"
                                                                                                                        px={3}
                                                                                                                        py={1}
                                                                                                                    >
                                                                                                                        {video.duree}
                                                                                                                    </Badge>
                                                                                                                </HStack>
                                                                                                                <VStack 
                                                                                                                    align={{ base: "center", sm: "end" }} 
                                                                                                                    spacing={1}
                                                                                                                >
                                                                                                                    <Text
                                                                                                                        fontWeight="medium"
                                                                                                                        fontSize="sm"
                                                                                                                        color={primaryColor}
                                                                                                                        textAlign={{ base: "center", sm: "right" }}
                                                                                                                    >
                                                                                                                        {video.nomvideo}
                                                                                                                    </Text>
                                                                                                                    <Text
                                                                                                                        fontSize="xs"
                                                                                                                        color={textColor}
                                                                                                                        opacity={0.7}
                                                                                                                        textAlign={{ base: "center", sm: "right" }}
                                                                                                                        noOfLines={2}
                                                                                                                    >
                                                                                                                        {video.description}
                                                                                                                    </Text>
                                                                                                                </VStack>
                                                                                                            </Stack>
                                                                                                        </CardBody>
                                                                                                    </Card>
                                                                                                </ScaleFade>
                                                                                            ))}
                                                                                        </VStack>

                                                                                        {/* Attachments Section */}
                                                                                        {partie.attachments?.length > 0 && (
                                                                                            <Box mt={6}>
                                                                                                <Divider mb={4} />
                                                                                                <Text
                                                                                                    fontSize="sm"
                                                                                                    fontWeight="semibold"
                                                                                                    color={primaryColor}
                                                                                                    mb={3}
                                                                                                >
                                                                                                    المرفقات:
                                                                                                </Text>
                                                                                                <VStack spacing={3} align="stretch">
                                                                                                    {partie.attachments.map((attachment, attIndex) => (
                                                                                                        <HStack
                                                                                                        onClick={()=>window.open(urlvideo+attachment.url)}
                                                                                                            key={attIndex}
                                                                                                            justify="space-between"
                                                                                                            p={3}
                                                                                                            bg="gray.50"
                                                                                                            borderRadius="lg"
                                                                                                            cursor="pointer"
                                                                                                            border="1px solid"
                                                                                                            borderColor="gray.200"
                                                                                                            _hover={{
                                                                                                                bg: "gray.100",
                                                                                                                transform: "translateY(-1px)"
                                                                                                            }}
                                                                                                            transition="all 0.3s ease"
                                                                                                        >
                                                                                                            <IconButton
                                                                                                                icon={<FaTrash />}
                                                                                                                size="xs"
                                                                                                                colorScheme="red"
                                                                                                                variant="ghost"
                                                                                                                onClick={() => handleDeleteAttachment(partieIndex, attIndex, chapterIndex)}
                                                                                                                borderRadius="full"
                                                                                                            />
                                                                                                            <Text fontSize="sm" textAlign="right" fontWeight="medium">
                                                                                                                {attachment.nom}
                                                                                                            </Text>
                                                                                                        </HStack>
                                                                                                    ))}
                                                                                                </VStack>
                                                                                            </Box>
                                                                                        )}
                                                                                    </Box>
                                                                                </Collapse>
                                                                            </Box>
                                                                        </SlideFade>
                                                                    ))}

                                                                    {/* Add New Partie Button */}
                                                                    <Box p={6}>
                                                                        <Button
                                                                            leftIcon={<AddIcon />}
                                                                            onClick={() => openNewPartieModal(chapter._id)}
                                                                            variant="outline"
                                                                            colorScheme="teal"
                                                                            size={buttonSize}
                                                                            w="full"
                                                                            borderRadius="xl"
                                                                            borderWidth="2px"
                                                                            _hover={{
                                                                                bg: "teal.50",
                                                                                borderColor: "teal.400",
                                                                                transform: "translateY(-2px)",
                                                                                shadow: "lg"
                                                                            }}
                                                                            transition="all 0.3s ease"
                                                                        >
                                                                            إضافة جزء جديد
                                                                        </Button>
                                                                    </Box>
                                                                </VStack>
                                                            </Box>
                                                        </Collapse>
                                                    </Box>
                                                ))}
                                            </VStack>
                                        </CardBody>
                                    </Card>
                                </Box>

                                {/* Enhanced Video Player Section */}
                                <Box 
                                    flex="1" 
                                    maxW={{ base: "100%", lg: "55%" }}
                                    order={{ base: 1, lg: 2 }}
                                >
                                    <Card bg={cardBg} shadow="2xl" borderRadius="3xl" overflow="hidden">
                                        <CardHeader bgGradient="linear(to-r, green.600, teal.600)" color="white" py={8}>
                                            <Stack 
                                                direction={{ base: "column", md: "row" }}
                                                justify="space-between"
                                                align={{ base: "center", md: "center" }}
                                                spacing={4}
                                            >
                                                <HStack spacing={3}>
                                                    <Box
                                                        p={2}
                                                        bg="whiteAlpha.200"
                                                        borderRadius="lg"
                                                        backdropFilter="blur(10px)"
                                                    >
                                                        <FaPlay size={24} />
                                                    </Box>
                                                    <Badge
                                                        bg="whiteAlpha.200"
                                                        color="white"
                                                        fontSize={{ base: "sm", md: "md" }}
                                                        px={4}
                                                        py={2}
                                                        borderRadius="full"
                                                        backdropFilter="blur(10px)"
                                                        border="1px solid"
                                                        borderColor="whiteAlpha.300"
                                                    >
                                                        مشغل الفيديو
                                                    </Badge>
                                                </HStack>
                                                <Text
                                                    fontSize={{ base: "lg", md: "xl" }}
                                                    fontWeight="bold"
                                                    textShadow="0 2px 4px rgba(0,0,0,0.3)"
                                                >
                                                    عرض المحتوى
                                                </Text>
                                            </Stack>
                                        </CardHeader>

                                        <CardBody p={{ base: 4, md: 6 }}>
                                            {selectedVideo ? (
                                                <VStack spacing={6} align="stretch">
                                                    <Card variant="outline" borderRadius="2xl" overflow="hidden" borderWidth="2px">
                                                        <CardBody p={0}>
                                                            <VideoPlayer
                                                                idvdocipher={selectedVideo.idvdocipher}
                                                                videoId={selectedVideo.idvdocipher}
                                                                video={selectedVideo}
                                                            />
                                                        </CardBody>
                                                    </Card>

                                                    <VStack align="start" spacing={4}>
                                                        <Heading
                                                            size={{ base: "md", md: "lg" }}
                                                            color={primaryColor}
                                                            textAlign="right"
                                                        >
                                                            {selectedVideo.nomvideo}
                                                        </Heading>

                                                        <Stack 
                                                            direction={{ base: "column", sm: "row" }}
                                                            spacing={4}
                                                            w="full"
                                                        >
                                                            <Badge
                                                                colorScheme="blue"
                                                                fontSize="sm"
                                                                px={4}
                                                                py={2}
                                                                borderRadius="full"
                                                                leftIcon={<FaClock />}
                                                            >
                                                                المدة: {selectedVideo.duree}
                                                            </Badge>
                                                            <Badge
                                                                colorScheme="purple"
                                                                fontSize="sm"
                                                                px={4}
                                                                py={2}
                                                                borderRadius="full"
                                                                leftIcon={<FaEye />}
                                                            >
                                                                جاري العرض
                                                            </Badge>
                                                        </Stack>

                                                        <Box
                                                            p={6}
                                                            bg="gray.50"
                                                            borderRadius="2xl"
                                                            w="full"
                                                            border="1px solid"
                                                            borderColor="gray.200"
                                                        >
                                                            <Text
                                                                color={textColor}
                                                                lineHeight="tall"
                                                                textAlign="right"
                                                                fontSize={{ base: "sm", md: "md" }}
                                                            >
                                                                {selectedVideo.description}
                                                            </Text>
                                                        </Box>
                                                    </VStack>
                                                </VStack>
                                            ) : (
                                                <VStack
                                                    spacing={6}
                                                    align="center"
                                                    justify="center"
                                                    h={{ base: "300px", md: "400px" }}
                                                    color={textColor}
                                                >
                                                    <Box
                                                        p={8}
                                                        bg="gray.100"
                                                        borderRadius="full"
                                                        opacity={0.5}
                                                    >
                                                        <FaVideo size={isMobile ? 48 : 64} />
                                                    </Box>
                                                    <VStack spacing={3}>
                                                        <Text 
                                                            fontSize={{ base: "lg", md: "xl" }} 
                                                            fontWeight="semibold"
                                                        >
                                                            لم يتم اختيار فيديو
                                                        </Text>
                                                        <Text 
                                                            opacity={0.7} 
                                                            textAlign="center"
                                                            fontSize={{ base: "sm", md: "md" }}
                                                        >
                                                            اختر فيديو من قائمة المحاور لبدء المشاهدة
                                                        </Text>
                                                    </VStack>
                                                </VStack>
                                            )}
                                        </CardBody>
                                    </Card>
                                </Box>
                            </Stack>
                        </Box>
                    </Flex>
                </Container>

                {/* Enhanced Video Upload Modal */}
                <Modal
                    isOpen={videoUploadModalOpen}
                    onClose={handleCloseVideoUploadModal}
                    size={modalSize}
                    isCentered
                    closeOnOverlayClick={!uploadAnimation}
                >
                    <ModalOverlay 
                        backdropFilter="blur(15px)" 
                        bg="blackAlpha.600"
                        animation="fadeIn 0.3s ease-out"
                    />
                    <ModalContent 
                        borderRadius="3xl" 
                        overflow="hidden" 
                        mx={isMobile ? 4 : 0} 
                        shadow="2xl"
                        transform={uploadAnimation ? "scale(1.02)" : "scale(1)"}
                        transition="all 0.3s cubic-bezier(0.4, 0, 0.2, 1)"
                        border="1px solid"
                        borderColor="whiteAlpha.200"
                    >
                        <ModalHeader
                            bgGradient="linear(135deg, blue.500 0%, purple.600 50%, pink.500 100%)"
                            color="white"
                            textAlign="center"
                            py={10}
                            position="relative"
                            overflow="hidden"
                            _before={{
                                content: '""',
                                position: "absolute",
                                top: 0,
                                left: 0,
                                right: 0,
                                bottom: 0,
                                bgGradient: "linear(45deg, transparent 30%, whiteAlpha.100 50%, transparent 70%)",
                                transform: uploadAnimation ? "translateX(100%)" : "translateX(-100%)",
                                transition: "transform 1s ease-in-out",
                            }}
                        >
                            <VStack spacing={4} position="relative" zIndex={1}>
                                <Box
                                    p={4}
                                    bg="whiteAlpha.200"
                                    borderRadius="2xl"
                                    backdropFilter="blur(10px)"
                                    border="1px solid"
                                    borderColor="whiteAlpha.300"
                                    transform={uploadAnimation ? "rotate(360deg) scale(1.1)" : "rotate(0deg) scale(1)"}
                                    transition="all 0.8s cubic-bezier(0.4, 0, 0.2, 1)"
                                >
                                    <FaVideo size={40} />
                                </Box>
                                <VStack spacing={2}>
                                    <Text 
                                        fontSize={{ base: "xl", md: "2xl" }} 
                                        fontWeight="bold" 
                                        textShadow="0 2px 4px rgba(0,0,0,0.3)"
                                    >
                                        {uploadAnimation ? "جاري رفع الفيديو..." : "رفع فيديو جديد"}
                                    </Text>
                                    <Text 
                                        fontSize="sm" 
                                        opacity={0.9}
                                        textAlign="center"
                                    >
                                        {uploadAnimation ? "يرجى الانتظار حتى اكتمال الرفع" : "اختر ملف فيديو وسيتم حساب المدة تلقائياً"}
                                    </Text>
                                </VStack>
                            </VStack>
                        </ModalHeader>
                        <ModalCloseButton 
                            color="white" 
                            size="lg"
                            isDisabled={uploadAnimation}
                            _hover={{
                                bg: "whiteAlpha.200",
                                transform: "scale(1.1)"
                            }}
                            transition="all 0.2s ease"
                        />

                        <ModalBody p={{ base: 6, md: 10 }}>
                            <VStack spacing={8}>
                                {/* Video Name Input */}
                                <FormControl>
                                    <FormLabel 
                                        color={textColor} 
                                        fontWeight="bold"
                                        fontSize="lg"
                                        mb={3}
                                        display="flex"
                                        alignItems="center"
                                        gap={2}
                                    >
                                        <Box w={2} h={2} bg="blue.500" borderRadius="full" />
                                        اسم الفيديو
                                    </FormLabel>
                                    <Input
                                        value={newVideo.name}
                                        onChange={(e) => setNewVideo({ ...newVideo, name: e.target.value })}
                                        placeholder="أدخل اسم الفيديو"
                                        borderRadius="2xl"
                                        borderWidth="2px"
                                        borderColor="gray.300"
                                        bg="gray.50"
                                        py={6}
                                        fontSize="lg"
                                        _focus={{
                                            borderColor: primaryColor,
                                            boxShadow: `0 0 0 3px ${primaryColor}20`,
                                            bg: "white",
                                            transform: "translateY(-2px)"
                                        }}
                                        _hover={{
                                            borderColor: "gray.400",
                                            bg: "white"
                                        }}
                                        transition="all 0.3s cubic-bezier(0.4, 0, 0.2, 1)"
                                        isDisabled={uploadAnimation}
                                    />
                                </FormControl>

                                {/* Video Description */}
                                <FormControl>
                                    <FormLabel 
                                        color={textColor} 
                                        fontWeight="bold"
                                        fontSize="lg"
                                        mb={3}
                                        display="flex"
                                        alignItems="center"
                                        gap={2}
                                    >
                                        <Box w={2} h={2} bg="green.500" borderRadius="full" />
                                        وصف الفيديو
                                    </FormLabel>
                                    <Textarea
                                        value={newVideo.description}
                                        onChange={(e) => setNewVideo({ ...newVideo, description: e.target.value })}
                                        placeholder="أدخل وصف م محور للفيديو"
                                        borderRadius="2xl"
                                        borderWidth="2px"
                                        borderColor="gray.300"
                                        bg="gray.50"
                                        py={4}
                                        fontSize="lg"
                                        rows={4}
                                        resize="vertical"
                                        _focus={{
                                            borderColor: primaryColor,
                                            boxShadow: `0 0 0 3px ${primaryColor}20`,
                                            bg: "white",
                                            transform: "translateY(-2px)"
                                        }}
                                        _hover={{
                                            borderColor: "gray.400",
                                            bg: "white"
                                        }}
                                        transition="all 0.3s cubic-bezier(0.4, 0, 0.2, 1)"
                                        isDisabled={uploadAnimation}
                                    />
                                </FormControl>

                                {/* Duration Display */}
                                <FormControl>
                                    <FormLabel 
                                        color={textColor} 
                                        fontWeight="bold"
                                        fontSize="lg"
                                        mb={3}
                                        display="flex"
                                        alignItems="center"
                                        gap={2}
                                    >
                                        <Box w={2} h={2} bg="purple.500" borderRadius="full" />
                                        مدة الفيديو
                                        {isCalculatingDuration && (
                                            <Spinner size="sm" color="purple.500" ml={2} />
                                        )}
                                    </FormLabel>
                                    <HStack spacing={4}>
                                        <Input
                                            value={newVideo.duree}
                                            onChange={(e) => setNewVideo({ ...newVideo, duree: e.target.value })}
                                            placeholder="مثال: 10:30"
                                            borderRadius="2xl"
                                            borderWidth="2px"
                                            borderColor={newVideo.duree ? "green.300" : "gray.300"}
                                            bg={newVideo.duree ? "green.50" : "gray.50"}
                                            py={6}
                                            fontSize="lg"
                                            _focus={{
                                                borderColor: primaryColor,
                                                boxShadow: `0 0 0 3px ${primaryColor}20`,
                                                bg: "white",
                                                transform: "translateY(-2px)"
                                            }}
                                            _hover={{
                                                borderColor: "gray.400",
                                                bg: "white"
                                            }}
                                            transition="all 0.3s cubic-bezier(0.4, 0, 0.2, 1)"
                                            isDisabled={uploadAnimation || isCalculatingDuration}
                                        />
                                        {newVideo.duree && (
                                            <Badge
                                                colorScheme="green"
                                                fontSize="md"
                                                px={4}
                                                py={2}
                                                borderRadius="xl"
                                                display="flex"
                                                alignItems="center"
                                                gap={2}
                                            >
                                                <FaClock />
                                                {newVideo.duree}
                                            </Badge>
                                        )}
                                    </HStack>
                                    {isCalculatingDuration && (
                                        <Text fontSize="sm" color="purple.600" mt={2} fontWeight="medium">
                                            جاري حساب مدة الفيديو تلقائياً...
                                        </Text>
                                    )}
                                </FormControl>

                                {/* Enhanced File Upload */}
                                <FormControl>
                                    <FormLabel 
                                        color={textColor} 
                                        fontWeight="bold"
                                        fontSize="lg"
                                        mb={3}
                                        display="flex"
                                        alignItems="center"
                                        gap={2}
                                    >
                                        <Box w={2} h={2} bg="orange.500" borderRadius="full" />
                                        ملف الفيديو
                                    </FormLabel>
                                    <Box
                                        position="relative"
                                        borderRadius="2xl"
                                        borderWidth="3px"
                                        borderStyle="dashed"
                                        borderColor={newVideo.file ? "green.400" : "gray.300"}
                                        bg={newVideo.file ? "green.50" : "gray.50"}
                                        p={8}
                                        textAlign="center"
                                        cursor={uploadAnimation ? "not-allowed" : "pointer"}
                                        _hover={{
                                            borderColor: uploadAnimation ? "gray.300" : "blue.400",
                                            bg: uploadAnimation ? "gray.50" : "blue.50",
                                            transform: uploadAnimation ? "none" : "translateY(-2px)"
                                        }}
                                        transition="all 0.3s cubic-bezier(0.4, 0, 0.2, 1)"
                                        onClick={() => !uploadAnimation && document.getElementById('video-file-input').click()}
                                    >
                                        <Input
                                            id="video-file-input"
                                            type="file"
                                            accept="video/*"
                                            onChange={(e) => handleVideoFileChange(e.target.files[0])}
                                            position="absolute"
                                            opacity={0}
                                            w="full"
                                            h="full"
                                            cursor="pointer"
                                            isDisabled={uploadAnimation}
                                        />
                                        <VStack spacing={4}>
                                            <Box
                                                p={4}
                                                bg={newVideo.file ? "green.100" : "gray.200"}
                                                borderRadius="2xl"
                                                color={newVideo.file ? "green.600" : "gray.600"}
                                                transform={isCalculatingDuration ? "scale(1.1) rotate(180deg)" : "scale(1)"}
                                                transition="all 0.5s ease"
                                            >
                                                <FaVideo size={32} />
                                            </Box>
                                            <VStack spacing={2}>
                                                <Text
                                                    fontSize="lg"
                                                    fontWeight="bold"
                                                    color={newVideo.file ? "green.600" : textColor}
                                                >
                                                    {newVideo.file ? "تم اختيار الملف ✓" : "اختر ملف الفيديو"}
                                                </Text>
                                                <Text
                                                    fontSize="sm"
                                                    color="gray.600"
                                                    textAlign="center"
                                                >
                                                    {newVideo.file 
                                                        ? `${newVideo.file.name} (${(newVideo.file.size / (1024 * 1024)).toFixed(2)} MB)`
                                                        : "اسحب الملف هنا أو انقر للاختيار"
                                                    }
                                                </Text>
                                            </VStack>
                                        </VStack>
                                    </Box>
                                </FormControl>

                                {/* Enhanced Upload Progress */}
                                {(uploadProgress > 0 || uploadAnimation) && (
                                    <Box w="full">
                                        <VStack spacing={4}>
                                            <HStack justify="space-between" w="full">
                                                <Text fontWeight="bold" color={textColor} fontSize="lg">
                                                    {uploadProgress === 100 ? "تم الرفع بنجاح! 🎉" : `جاري الرفع: ${uploadProgress}%`}
                                                </Text>
                                                <Badge
                                                    colorScheme={uploadProgress === 100 ? "green" : "blue"}
                                                    fontSize="md"
                                                    px={3}
                                                    py={1}
                                                    borderRadius="full"
                                                >
                                                    {uploadProgress}%
                                                </Badge>
                                            </HStack>
                                            <Box w="full" position="relative">
                                                <Progress
                                                    value={uploadProgress}
                                                    colorScheme={uploadProgress === 100 ? "green" : "blue"}
                                                    borderRadius="full"
                                                    size="lg"
                                                    bg="gray.200"
                                                    hasStripe={uploadProgress < 100}
                                                    isAnimated={uploadProgress < 100}
                                                />
                                                {uploadProgress === 100 && (
                                                    <Box
                                                        position="absolute"
                                                        top="50%"
                                                        left="50%"
                                                        transform="translate(-50%, -50%)"
                                                        color="white"
                                                        fontWeight="bold"
                                                        fontSize="sm"
                                                    >
                                                        مكتمل ✓
                                                    </Box>
                                                )}
                                            </Box>
                                            {uploadAnimation && uploadProgress < 100 && (
                                                <Text fontSize="sm" color="blue.600" textAlign="center">
                                                    يرجى عدم إغلاق النافذة أثناء الرفع...
                                                </Text>
                                            )}
                                        </VStack>
                                    </Box>
                                )}
                            </VStack>
                        </ModalBody>

                        <ModalFooter p={{ base: 6, md: 10 }} pt={0}>
                            <Stack 
                                direction={{ base: "column", sm: "row" }}
                                spacing={4} 
                                w="full"
                            >
                                <Button
                                    variant="outline"
                                    onClick={handleCloseVideoUploadModal}
                                    borderRadius="2xl"
                                    borderWidth="2px"
                                    px={8}
                                    py={6}
                                    fontSize="lg"
                                    w={{ base: "full", sm: "auto" }}
                                    isDisabled={uploadAnimation}
                                    _hover={{
                                        bg: "gray.100",
                                        transform: uploadAnimation ? "none" : "translateY(-2px)",
                                        shadow: "lg"
                                    }}
                                    transition="all 0.3s ease"
                                >
                                    إلغاء
                                </Button>
                                <Button
                                    bgGradient="linear(135deg, blue.500 0%, purple.600 50%, pink.500 100%)"
                                    color="white"
                                    onClick={handleAddVideo}
                                    isDisabled={!newVideo.file || !newVideo.name || uploadAnimation || isCalculatingDuration}
                                    isLoading={uploadAnimation}
                                    loadingText="جاري الرفع..."
                                    borderRadius="2xl"
                                    px={8}
                                    py={6}
                                    fontSize="lg"
                                    fontWeight="bold"
                                    w={{ base: "full", sm: "auto" }}
                                    _hover={{
                                        bgGradient: "linear(135deg, blue.600 0%, purple.700 50%, pink.600 100%)",
                                        transform: uploadAnimation ? "none" : "translateY(-2px)",
                                        shadow: "2xl"
                                    }}
                                    _active={{
                                        transform: "scale(0.98)"
                                    }}
                                    transition="all 0.3s cubic-bezier(0.4, 0, 0.2, 1)"
                                    rightIcon={!uploadAnimation ? <FaVideo /> : undefined}
                                >
                                    {uploadAnimation ? "جاري الرفع..." : "رفع الفيديو"}
                                </Button>
                            </Stack>
                        </ModalFooter>
                    </ModalContent>
                </Modal>

                {/* Enhanced Attachment Upload Modal */}
                <Modal
                    isOpen={attachmentModalOpen}
                    onClose={() => setAttachmentModalOpen(false)}
                    size={modalSize}
                    isCentered
                >
                    <ModalOverlay backdropFilter="blur(10px)" />
                    <ModalContent borderRadius="3xl" overflow="hidden" mx={isMobile ? 4 : 0} shadow="2xl">
                        <ModalHeader
                            bgGradient="linear(to-r, green.500, teal.500)"
                            color="white"
                            textAlign="center"
                            py={8}
                        >
                            <VStack spacing={3}>
                                <Box
                                    p={3}
                                    bg="whiteAlpha.200"
                                    borderRadius="xl"
                                    backdropFilter="blur(10px)"
                                >
                                    <FaPaperclip size={32} />
                                </Box>
                                <Text fontSize={{ base: "lg", md: "xl" }} fontWeight="bold" textShadow="0 2px 4px rgba(0,0,0,0.3)">إضافة مرفق</Text>
                            </VStack>
                        </ModalHeader>
                        <ModalCloseButton color="white" />

                        <ModalBody p={{ base: 4, md: 8 }}>
                            <VStack spacing={6}>
                                <FormControl>
                                    <FormLabel color={textColor} fontWeight="semibold">اسم المرفق</FormLabel>
                                    <Input
                                        value={AttchmentName}
                                        onChange={(e) => setAttchmentName(e.target.value)}
                                        placeholder="أدخل اسم المرفق"
                                        borderRadius="xl"
                                        borderWidth="2px"
                                        borderColor="gray.300"
                                        _focus={{
                                            borderColor: primaryColor,
                                            boxShadow: `0 0 0 1px ${primaryColor}`
                                        }}
                                    />
                                </FormControl>

                                <FormControl>
                                    <FormLabel color={textColor} fontWeight="semibold">ملف المرفق</FormLabel>
                                    <Input
                                        type="file"
                                        onChange={(e) => setAttachments(e.target.files[0])}
                                        borderRadius="xl"
                                        borderWidth="2px"
                                        borderColor="gray.300"
                                        p={3}
                                    />
                                </FormControl>
                            </VStack>
                        </ModalBody>

                        <ModalFooter p={{ base: 4, md: 8 }} pt={0}>
                            <Stack 
                                direction={{ base: "column", sm: "row" }}
                                spacing={4} 
                                w="full"
                            >
                                <Button
                                    variant="outline"
                                    onClick={() => setAttachmentModalOpen(false)}
                                    borderRadius="xl"
                                    borderWidth="2px"
                                    px={8}
                                    w={{ base: "full", sm: "auto" }}
                                >
                                    إلغاء
                                </Button>
                                <Button
                                    bgGradient="linear(to-r, green.500, teal.500)"
                                    color="white"
                                    onClick={() => saveAttachmentsToPartie(selectedChapterIndex, selectedPartieIndex, attachments)}
                                    isDisabled={!attachments || !AttchmentName}
                                    borderRadius="xl"
                                    px={8}
                                    w={{ base: "full", sm: "auto" }}
                                    _hover={{
                                        bgGradient: "linear(to-r, green.600, teal.600)",
                                        transform: "translateY(-2px)",
                                        shadow: "xl"
                                    }}
                                    transition="all 0.3s ease"
                                >
                                    رفع المرفق
                                </Button>
                            </Stack>
                        </ModalFooter>
                    </ModalContent>
                </Modal>

                {/* New Chapter Modal */}
                <NewChapterToCourse
                    isOpen={isOpen}
                    onClose={onClose}
                    courseId={id}
                    onChapterAdded={fetchCourseData}
                />

                {/* New Partie Modal */}
                <AddPartieForm
                    isOpen={isAddNewPartieOpen}
                    onClose={() => setisAddNewPartieOpen(false)}
                    courseId={id}
                    chapterId={ChaterID}
                    onPartieAdded={fetchCourseData}
                />
            </Flex>
        </>
    );
};

export default CourseDetailsContent;

